import { Pipe, PipeTransform } from '@angular/core';
import { getElapsedTime } from '../utils/relative-time-utils';

@Pipe({
  standalone: false,
  name: 'timeFrame',
})
export class TimeFramePipe implements PipeTransform {
  transform(startDate?: string, endDate?: string): string {
    if (!startDate || !endDate) {
      return '';
    }

    const start = new Date(startDate);
    const end = new Date(endDate);

    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return 'Invalid dates';
    }

    return getElapsedTime(start, end);
  }
}
